import { SourceLegends } from "../@types/Source";

export const sourceLegends: SourceLegends = {
  "a&d_ua-651ble": {
    name: "A&D 651 BLE",
    systolicColor: "#7562A8",
    diastolicColor: "#C87C36",
    shape: "circle",
    lineOpacity: 0.38,
  },
  "apple-health": {
    name: "Apple Health",
    color: "#7562A8",
    shape: "line",
  },
  "bodytrace-bp": {
    name: "Bodytrace",
    systolicColor: "#6697F4",
    diastolicColor: "#BE8AAD",
    color: "#7562A8",
    shape: "circle",
    lineOpacity: 0.38,
  },
  "bodytrace-scale": {
    name: "Bodytrace Scale",
    color: "#7562A8",
    shape: "circle",
    lineOpacity: 0.38,
  },
  dexcom: {
    name: "Dexcom",
    color: "#59a618",
    shape: "circle",
    lineOpacity: 0.38,
  },
  fitbit: {
    name: "Fitbit",
    color: "#7562A8",
    shape: "line",
    lineOpacity: 0.38,
  },
  "google-health": {
    name: "Google Health",
    color: "#54A6AA",
    shape: "line",
    lineOpacity: 0.38,
  },
  "google-fit": {
    name: "Google Fit",
    color: "#5CAB57",
    shape: "line",
    lineOpacity: 0.38,
  },
  "mir-smart-one": {
    name: "MIR Smart One",
    color: "#C87C36",
    shape: "circle",
    lineOpacity: 0.38,
    isDotClickable: true,
  },
  "mir-spirobank-smart": {
    name: "MIR Spirobank Smart",
    color: "#C87C36",
    shape: "circle",
    lineOpacity: 0.38,
    isDotClickable: true,
  },
  "mir-unknown-spirometer": {
    name: "MIR Unknown Spirometer",
    color: "#C87C36",
    shape: "circle",
    lineOpacity: 0.38,
    isDotClickable: true,
  },
  "monitoring-portal": {
    name: "Portal",
    labelKey: "chart_source_portal",
    color: "#666666",
    shape: "square",
    lineOpacity: 0.38,
  },
  // EN-4857: historical spirometry imported for Manchester (NuvoAir export). These rows have
  // no spirometry session behind them, so the dot is not clickable.
  nuvoair: {
    name: "Imported data",
    labelKey: "chart_source_importedData",
    color: "#7562A8",
    shape: "circle",
    lineOpacity: 0.38,
  },
  "load-data": {
    name: "Unknown",
    labelKey: "chart_source_unknown",
    color: "#7562A8",
    shape: "circle",
    lineOpacity: 0.38,
  },
  "nonin-3230": {
    name: "Nonin 3230",
    color: "#C87C36",
    shape: "circle",
    lineOpacity: 0.38,
  },
  "ihealth-air-po3m": {
    name: "iHealth Air",
    color: "#ff7f20",
    shape: "circle",
    lineOpacity: 0.38,
  },
  "ihealth-thermo-nt13b": {
    name: "iHealth ThermoPro",
    color: "#ff7f20",
    shape: "circle",
    lineOpacity: 0.38,
  },
  "pmp-app-manual": {
    name: "App manual",
    labelKey: "chart_source_appManual",
    color: "#297A94",
    shape: "triangle",
    lineOpacity: 0.38,
  },
  withings: {
    name: "Withings",
    color: "#7562A8",
    shape: "line",
  },
  "withings-bp-auto": {
    name: "Withings BP Auto",
    color: "#7562A8",
    shape: "line",
  },
  "withings-device": {
    name: "Withings Device",
    color: "#7562A8",
    shape: "line",
  },
  "withings-device-group": {
    name: "Withings Device Group",
    color: "#7562A8",
    shape: "line",
  },
  "withings-manual": {
    name: "Withings Manual",
    color: "#7562A8",
    shape: "line",
  },
  aiocare: {
    name: "AioCare",
    color: "#2196f3",
    shape: "circle",
    lineOpacity: 0.38,
  },
  unknown: {
    name: "Unknown",
    color: "#7562A8",
    shape: "circle",
    lineOpacity: 0.38,
  },
  archived: {
    name: "",
    color: "#939393",
    shape: "circle",
    isDotClickable: true,
    lineOpacity: 0.38,
  },
  fibricheck: {
    name: "Fibricheck",
    color: "#2196f3",
    shape: "circle",
    lineOpacity: 0.38,
  },
  emedrenal: {
    name: "eMedRenal",
    color: "#2196f3",
    shape: "circle",
    lineOpacity: 0.38,
  },
  dialysis: {
    name: "Dialysis",
    labelKey: "chart_source_dialysis",
    color: "#457B9D",
    shape: "triangle",
    lineOpacity: 0.38,
  },
  "masimo-mighty-sat-rx": {
    name: "Masimo MightySat Rx",
    color: "#CE0E2D",
    shape: "circle",
    lineOpacity: 0.38,
  },
  "pre-dialysis": {
    name: "Pre-dialysis",
    labelKey: "chart_source_preDialysis",
    color: "#C87C36",
    shape: "circle",
    lineOpacity: 0.38,
  },
  "post-dialysis": {
    name: "Post-dialysis",
    labelKey: "chart_source_postDialysis",
    color: "#7562A8",
    shape: "circle",
    lineOpacity: 0.38,
  },
};
